export default __webpack_public_path__ + "static/web-application-development-peerbits-1de4c24e4d3bec71d9ba69b509dceae3.png";